import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { ProductObject, productTitleMap } from "types";
import { SecondaryButton } from "@/components/Common/SecondaryButton";

interface RemovedProductTypeEntry {
    productObject: ProductObject;
    count: number;
}

interface RemoveProductTypesModalProps {
    isOpen: boolean;
    removedProductTypes: RemovedProductTypeEntry[];
    onCancel: () => void;
    onConfirm: () => void;
}

export const RemoveProductTypesModal = ({
    isOpen,
    removedProductTypes,
    onCancel,
    onConfirm,
}: RemoveProductTypesModalProps) => {
    return (
        <Modal isOpen={isOpen} size="small" onClose={onCancel}>
            <Modal.Header>Remove Product Types</Modal.Header>
            <Modal.Body>
                <p className="text-center text-gray-darker">{getRemoveProductTypesCopy(removedProductTypes)}</p>
            </Modal.Body>
            <Modal.Footer className="flex justify-center space-x-4">
                <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
                <SubmitButton color="danger" onClick={onConfirm}>
                    Remove Product Types
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};

const getRemoveProductTypesCopy = (entries: RemovedProductTypeEntry[]) => {
    if (entries.length === 0) {
        return "Are you sure you want to remove these product types?";
    }

    const productTypeParts = entries.map(({ productObject, count }) => {
        const productLabel = productTitleMap[productObject];
        const displayLabel = count === 1 && productLabel.endsWith("s") ? productLabel.slice(0, -1) : productLabel;

        return (
            <span key={`${productObject}-${count}`}>
                <var data-var="count">{count}</var> <var data-var="productType">{displayLabel}</var>
            </span>
        );
    });

    let productTypeList: React.ReactNode = productTypeParts[0];

    if (productTypeParts.length === 2) {
        productTypeList = (
            <>
                {productTypeParts[0]} and {productTypeParts[1]}
            </>
        );
    } else if (productTypeParts.length > 2) {
        productTypeList = (
            <>
                {productTypeParts.slice(0, -1).map((part) => (
                    <React.Fragment key={(part as React.ReactElement).key}>{part}, </React.Fragment>
                ))}
                and {productTypeParts[productTypeParts.length - 1]}
            </>
        );
    }

    return (
        <>
            This button currently displays <var data-var="productTypeList">{productTypeList}</var>. Are you sure you
            want to remove them?
        </>
    );
};
